import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getAsset } from '../../../../util/assets';

const propTypes = {
  className: PropTypes.string,
};

const PressLogos = ({ className }) => {
  const classes = classNames({
    'signup-layout-press-logos': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <div className="d-flex align-items-center mb-2">
        Over 17,000+&nbsp;
        <img className="stars" src={getAsset('/five-stars.png')} alt="" />
        &nbsp;reviews
      </div>
      <img
        src={getAsset('/press-logos-desktop-grey.png')}
        alt="press logos"
        className="logos d-none d-md-block"
      />
      <img
        src={getAsset('/press-logos-mobile-grey.png')}
        alt="press logos"
        className="logos d-block d-md-none"
      />
    </div>
  );
};

PressLogos.propTypes = propTypes;

export default PressLogos;
